module.exports = __webpack_public_path__ + "static/media/automation.c339c496.jpg";